import React from 'react'
const CTA = () => {
  return (
    <div className='cta'>
        <a href='https://drive.google.com/drive/folders/15qhPgEMgB1LJqA-lMKzMeMHmblB_q1iU?usp=sharing' className='btn'>Download CV</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA